import './Shell.scss';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Device from '@/components/application/Device';
import Loading from '@/components/atoms/Loading';
import query from '@/state/query';
import { ApplicationContext, ApplicationProvider, StorageProvider } from '@/state/providers';
import Analytics from '@/components/application/Analytics';
import BurgerMenuOverlay from '@/components/layouts/BurgerMenuOverlay';
import RegisterInterestOverlay from '@/components/layouts/RegisterInterestOverlay';
import DisclaimerOverlay from '@/components/layouts/DisclaimerOverlay';
import CookieNoticeOverlay from '@/components/layouts/CookieNoticeOverlay';
import { StateProvider } from '@/state/store';
import FullscreenOverlay from '@/components/atoms/FullscreenOverlay';
import FullscreenOverlayScroll from '@/components/atoms/FullscreenOverlayScroll';
import PlatformController from '@/components/controllers/PlatformController';

const Home = React.lazy(() => import(/* webpackChunkName: "home" */ '@/routes/Home'));
const Menu = React.lazy(() => import(/* webpackChunkName: "menu" */ '@/routes/Menu'));
const Serenely = React.lazy(() => import(/* webpackChunkName: "serenely" */ '@/routes/moments/Serenely'));
const Effortlessly = React.lazy(() => import(/* webpackChunkName: "effortlessly" */ '@/routes/moments/Effortlessly'));
const Powerfully = React.lazy(() => import(/* webpackChunkName: "powerfully" */ '@/routes/moments/Powerfully'));
const Smartly = React.lazy(() => import(/* webpackChunkName: "smartly" */ '@/routes/moments/Smartly'));

const ShellComponent = ({ data }) => {
    PlatformController();

    if (data.device) {
        return (
            <Router basename={window.HELIOS.aemBasePath}>
                <Analytics adobeTaggingObj={window.HELIOS.adobe.tagging}>
                    <StateProvider>
                        <Device data={data.device}>
                            <FullscreenOverlay />
                            <FullscreenOverlayScroll data={data.device.ios} />
                            <div className="Shell">
                                <React.Suspense fallback={<Loading />}>
                                    <Switch>
                                        <Route exact path="/" component={Home} />
                                        <Route path="/menu.html" component={Menu} />
                                        <Route path="/serenely.html" component={Serenely} />
                                        <Route path="/effortlessly.html" component={Effortlessly} />
                                        <Route path="/powerfully.html" component={Powerfully} />
                                        <Route path="/smartly.html" component={Smartly} />
                                    </Switch>
                                </React.Suspense>
                            </div>
                            <BurgerMenuOverlay />
                            <RegisterInterestOverlay />
                            <DisclaimerOverlay />
                            <CookieNoticeOverlay />
                        </Device>
                    </StateProvider>
                </Analytics>
            </Router>
        );
    }
    return <Loading />;
};

const ShellRenderer = () => {
    const [data, setter] = useContext(ApplicationContext);
    query(window.HELIOS.selectors.application, setter);
    return <ShellComponent data={data} />;
};

const Shell = () => (
    <StorageProvider>
        <ApplicationProvider>
            <ShellRenderer />
        </ApplicationProvider>
    </StorageProvider>
);

export default Shell;
